import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import CustomSelect from "../components/CustomSelect"; 
import { formatMoneyLoose,formatMoney } from "../utils/formatMoney";
import "./AddNewProduct.css";
import { Segmented, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { motion } from "framer-motion";
import editIcon from "../assets/edit.svg";
import deleteIcon from "../assets/delete.svg"
import ConfirmModal from "../components/ConfirmModal";
import uploadIcon from "../assets/upload.svg";
import axios from "../axiosSetup";
import InfoTooltip from "../components/InfoTooltip";
import Breadcrumbs from "../components/Breadcrumbs";
import CustomTooltip from "../components/CustomTooltip";

 
const getProductImageUrl = (productId) => `${axios.defaults.baseURL}/product/${productId}/image`;

/* STATIC FALLBACKS */
const TYPE_LIST = [
  "Never Diminishing",
  "Component Product",
  "Serialized",
  "Sellable",
  "Assembled Product",
  "Obsolete",
  "Batch Tracked",
  "Purchasable"
];

const SUPPLEMENTARY_UNIT_OPTIONS = [
  "c/k (Carats (1 metric carat = 2 × 10-4 kg))",
  "ce/el (Number of cells)",
  "ct/l (Carrying capacity in tonnes<1>)",
  "g (Gram)",
  "gi F/S (Gram of fissile isotopes)",
  "GT (Gross tonnage)",
  "kg C5H14ClNO (Kilogram of choline chloride)",
  "kg H2O2 (Kilogram of hydrogen peroxide)",
  "kg K2O (Kilogram of potassium oxide)",
  "kg KOH (Kilogram of potassium hydroxide (caustic potash))",
  "kg met.am. (Kilogram of methylamines)",
  "kg N (Kilogram of nitrogen)",
  "kg NaOH (Kilogram of sodium hydroxide (caustic soda))",
  "kg/net eda (Kilogram drained net weight)",
  "kg P2O5 (Kilogram of diphosphorus pentaoxide)",
  "kg U (Kilogram of uranium)",
  "kg 90 % sdt (Kilogram of substance 90 % dry)",
  "1,000 kWh (Thousand kilowatt hours)",
  "l (Litre)",
  "l alc. 100% (Litre pure (100 %) alcohol)",
  "1,000 l (Thousand litres)",
  "m (Metre)",
  "m2 (Square metre)",
  "m3 (Cubic metre)",
  "1,000 m3 (Thousand cubic metres)",
  "pa (Number of pairs)",
  "p/st (Number of items)",
  "100 p/st (Hundred items)",
  "1,000 p/st (Thousand items)",
  "TJ (Terajoule (gross calorific value))",
];

const AddNewProduct = () => {
  const navigate = useNavigate();
  const { productId:id } = useParams();
  const location = useLocation();
  const editingProductFromState = location.state?.product || null;
  const isEditMode = !!id;
const [countries, setCountries] = useState([]);
const imageSrcRef = React.useRef(null);
  const [apiGroups, setApiGroups] = useState([]);
  const [productCategoryOptions, setProductCategoryOptions] = useState([]);
  const [apiSubGroups, setApiSubGroups] = useState([]);
  const [apiBrands, setApiBrands] = useState([]);
  const [entityOptions, setEntityOptions] = useState([]);
  const [unitsList, setUnitsList] = useState([]);
const [previewUrl, setPreviewUrl] = useState(null);
const [isConfirmOpen, setIsConfirmOpen] = useState(false);
const [pendingSave, setPendingSave] = useState(null); 
const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
const [deleteTarget, setDeleteTarget] = useState(null); 
const [deleteType, setDeleteType] = useState(null); // "unit" or "tier
const [purchaseAccounts, setPurchaseAccounts] = useState([]);
const [salesAccounts, setSalesAccounts] = useState([]);
const [imgError, setImgError] = useState(false);
const [imageUploadError, setImageUploadError] = useState("");
const [finalImageUrl, setFinalImageUrl] = useState(null);
const [imageSrc, setImageSrc] = useState("/no-image.jpg");
const MAX_IMAGE_SIZE_BYTES = 3 * 1024 * 1024;
useEffect(() => {
  if (previewUrl) {
    setImageSrc(previewUrl);
  } else if (finalImageUrl) {
    setImageSrc(finalImageUrl);
  } else {
    setImageSrc(null);
  }
}, [previewUrl, finalImageUrl]);


const [isImageRemoved, setIsImageRemoved] = useState(false);

  const [form, setForm] = useState({
    productCode: "",
    productDescription: "",

    productGroup: "",
    productCategory: "",
    purchaseAccount: "",
    sageSalesAccount: "",

    // productQty: "",
    salesQty: "",
    purchaseQty: "",
    countryOfOrigin: "",
    supplementaryUnit: null,
    commerceCode: "",

    notes: null,
    reminders: null,
    comments: null,
    addToSales: false,
    addToPurchase: false,

    salesDefaultSellPrice: "",
    salesMinSellPrice: "",
    salesMinSaleQty: "",
    salesDefaultPurchasePrice: "",
    landedCost: "",

    types: TYPE_LIST.reduce((o, t) => ({ ...o, [t]: false }), {}),

    units: []
  });

  const [image, setImage] = useState({ file: null, isChanged: false });

  const [salesTiers, setSalesTiers] = useState([]);
  const [newSalesTier, setNewSalesTier] = useState({
    entity: "",
    tier: "",
    price: "",
    landedCost: "",
    minimumSellPrice:"",
    productCode: "",
    sku: "",
    // description: "",
    commerceCode: "",          //  NEW
  // customsDescription: "",
  active: true 
  });

  const [newUnit, setNewUnit] = useState({
    name: "",
    conversionRate: "",
    purchasable: true,
    packSize: "",
    barcode: "",
    weight: "",
    entity: "", 
    dimensions: { width: null, height: null, depth: null }
  });
  const [isAddUnitOpen, setIsAddUnitOpen] = useState(false);
  const [isEditUnitOpen, setIsEditUnitOpen] = useState(false);
  const [editUnitIndex, setEditUnitIndex] = useState(null);

  const [isAddSalesTierOpen, setIsAddSalesTierOpen] = useState(false);
  const [isEditSalesTierOpen, setIsEditSalesTierOpen] = useState(false);
  const [editSalesTierIndex, setEditSalesTierIndex] = useState(null);

  const [activeTab, setActiveTab] = useState("Generic Details");
  const editEntitySummary = [
    ...new Set(
      (salesTiers || [])
        .map((tier) => tier.entity)
        .map((entity) => String(entity || "").trim())
        .filter(Boolean)
    ),
  ].join(", ");

 const [errors, setErrors] = useState({});
  const [unitErrors, setUnitErrors] = useState({});
  const [salesTierErrors, setSalesTierErrors] = useState({});
 const sanitizeNoLeadingSpaces = (val) => val.replace(/^\s+/, "");
 const trimText = (val) => String(val ?? "").trim();
 const PRODUCT_FIELD_LIMITS = {
  productCode: 100,
  productCategory: 100,
  productDescription: 500,
  reminders: 1024,
  notes: 1024,
  comments: 1024,
  commerceCode: 14,
  barcode: 200,
 };

 const trimToFieldLimit = (key, value) => {
  const stringValue = String(value ?? "");

  switch (key) {
    case "productDescription":
    case "notes":
    case "reminders":
    case "comments":
    case "barcode":
      return stringValue.slice(0, PRODUCT_FIELD_LIMITS[key]);
    case "commerceCode":
      return stringValue.slice(0, PRODUCT_FIELD_LIMITS.commerceCode);
    default:
      return value;
  }
 };

 const getFieldValidationError = (key, value) => {
  const trimmed = trimText(value);

  switch (key) {
    case "productCode":
      if (!trimmed) return "Product Code cannot be empty.";
      if (trimmed.length > PRODUCT_FIELD_LIMITS.productCode) {
        return `Product Code cannot exceed ${PRODUCT_FIELD_LIMITS.productCode} characters.`;
      }
      return "";

    case "productDescription":
      if (!trimmed) return "Product Description is required.";
      if (trimmed.length > PRODUCT_FIELD_LIMITS.productDescription) {
        return `Product Description cannot exceed ${PRODUCT_FIELD_LIMITS.productDescription} characters.`;
      }
      return "";

    case "productCategory":
      if (trimmed.length > PRODUCT_FIELD_LIMITS.productCategory) {
        return `Product Category cannot exceed ${PRODUCT_FIELD_LIMITS.productCategory} characters.`;
      }
      return "";

    case "reminders":
    case "notes":
    case "comments":
      if (trimmed && trimmed.length > PRODUCT_FIELD_LIMITS[key]) {
        return `${key.charAt(0).toUpperCase() + key.slice(1)} cannot exceed ${PRODUCT_FIELD_LIMITS[key]} characters.`;
      }
      return "";

    case "commerceCode":
      if (!trimmed) return "Commerce Code is required.";
      if (!/^\d+$/.test(trimmed)) {
        return "Commerce Code must contain digits only.";
      }
      if (trimmed.length < 6) {
        return "Commerce Code must be at least 6 digits.";
      }
      if (trimmed.length > PRODUCT_FIELD_LIMITS.commerceCode) {
        return `Commerce Code cannot exceed ${PRODUCT_FIELD_LIMITS.commerceCode} digits.`;
      }
      return "";

    case "barcode":
      if (trimmed && trimmed.length > PRODUCT_FIELD_LIMITS.barcode) {
        return `Barcode cannot exceed ${PRODUCT_FIELD_LIMITS.barcode} characters.`;
      }
      return "";

    default:
     return "";
   }
  };

 const getSellPriceMismatchError = (defaultSellPrice, minimumSellPrice) => {
  const hasDefault = String(defaultSellPrice ?? "").trim() !== "";
  const hasMinimum = String(minimumSellPrice ?? "").trim() !== "";

  if (!hasDefault || !hasMinimum) return "";

  const defaultValue = Number(defaultSellPrice);
  const minimumValue = Number(minimumSellPrice);

  if (Number.isNaN(defaultValue) || Number.isNaN(minimumValue)) return "";

  return defaultValue < minimumValue
    ? "Default Sell Price cannot be lower than the Minimum Sell Price."
    : "";
 };

 const syncSellPriceValidation = (defaultSellPrice, minimumSellPrice) => {
  const mismatchError = getSellPriceMismatchError(defaultSellPrice, minimumSellPrice);

  setErrors((prev) => {
    const next = { ...prev };
    delete next["sale.defaultSellPrice"];
    delete next["sale.minimumSellPrice"];

    if (mismatchError) {
      next["sale.defaultSellPrice"] = mismatchError;
      next["sale.minimumSellPrice"] = mismatchError;
    }

    return next;
  });
 };
  const [currencyMap, setCurrencyMap] = useState({});
const [isDropdownLoading, setIsDropdownLoading] = useState(true);
const [isProductLoading, setIsProductLoading] = useState(isEditMode);

useEffect(() => {
  const fetchDropdowns = async () => {
    setIsDropdownLoading(true);
    try {
      const [
        groupsRes,
        purchaseAccRes,
        salesAccRes,
        entityRes,
        countriesRes,
        productCategoryRes
      ] = await Promise.all([
        axios.get("/dropdown/product-groups").catch(() => ({ data: [] })),
        axios.get("/dropdown/accounts?startsWith=COST").catch(() => ({ data: [] })),
        axios.get("/dropdown/accounts?startsWith=Sales").catch(() => ({ data: [] })),
        axios.get("/dropdown/entity").catch(() => ({ data: [] })), // ✅ ONLY ONCE
        axios.get("/dropdown/countries").catch(() => ({ data: [] })),
        axios.get("/dropdown/product-categories").catch(() => ({ data: [] }))
      ]);

      // ---------- Product groups ----------
      setApiGroups((groupsRes?.data || []).map(g => ({ value: g, label: g })));

      // ---------- Accounts ----------
      setPurchaseAccounts((purchaseAccRes?.data || []).map(a => ({ value: a, label: a })));
      setSalesAccounts((salesAccRes?.data || []).map(a => ({ value: a, label: a })));

      // ---------- Entity + Currency (SINGLE SOURCE) ----------
      const entities = entityRes?.data || [];

      // Dropdown options
      setEntityOptions(entities.map(e => e.entity));

      // Currency map
      const map = {};
      entities.forEach(e => {
        if (e?.entity) {
          map[e.entity] = e.currency || "";
        }
      });
      setCurrencyMap(map);

      // ---------- Countries ----------
      setCountries((countriesRes?.data || []).map(c => c.countryCode));
      setProductCategoryOptions(
        (productCategoryRes?.data || []).map((category) =>
          typeof category === "string"
            ? { value: category, label: category }
            : {
                value: category?.value || category?.name || category?.label || "",
                label: category?.label || category?.name || category?.value || "",
              }
        ).filter((category) => category.value)
      );

    } catch (err) {
      console.error("Dropdown error", err);
    } finally {
      setIsDropdownLoading(false);
    }
  };

  fetchDropdowns();
}, [isEditMode]);


  // Load editing product: prefer location.state, otherwise fetch by id
useEffect(() => {
  const loadProduct = async () => {
    if (!isEditMode) {
      setIsProductLoading(false);
      return;
    }
    setIsProductLoading(true);

    try {
      const res = await axios.get(`/product/${id}`);
      const product = res.data;

      if (!product) return;

      // ✅ 1️⃣ restore old behavior
      applyProductToForm(product);

      // ✅ 2️⃣ image handling (fixed version)
      const img = product.imageUrl;

      setFinalImageUrl(
        img
          ? (img.startsWith("https")
              ? img
              : getProductImageUrl(id))
          : null
      );

    } catch (err) {
      console.error("Failed to load product for edit:", err);
    } finally {
      setIsProductLoading(false);
    }
  };

  loadProduct();
}, [isEditMode, id]);



 const applyProductToForm = (p) => {
  if (!p) return;

  setForm((f) => ({
    ...f,

    productCode: p.productCode || "",
    productDescription: p.productDescription || "",

    productGroup: p.productGroup || "",
    productCategory: p.productCategory || p.category || "",
    // productSubGroup: p.productSubGroup || null,
    // productBrand: p.productBrand || null,
     purchaseAccount: p.purchaseAccount || "",
    sageSalesAccount: p.sageSalesAccount ?? "",

    // productQty: p.template?.productDefaultLabelQuantity ?? "",
    salesQty: p.template?.salesOrderDefaultLabelQuantity ?? "",
    purchaseQty: p.template?.purchaseOrdersDefaultLabelQuantity ?? "",

    countryOfOrigin: p.internationalAttributes?.countryOfOrigin || "",
    supplementaryUnit: p.internationalAttributes?.supplementaryUnit || null,
    commerceCode: p.internationalAttributes?.commerceCode || "",

    notes: p.notes || "",
    reminders: p.reminder || "", 
    comments: p.comments || "",
  addToSales: p.addToSalesQuoteAndOrder === true || p.addToSalesQuoteAndOrder === "true",
addToPurchase: p.addToPurchaseOrder === true || p.addToPurchaseOrder === "true",




    salesDefaultSellPrice: p.sale?.defaultSellPrice ?? "",
    salesMinSellPrice: p.sale?.minimumSellPrice ?? "",
    salesMinSaleQty:
      p.sale?.minimumOrderQuantity ?? "",
    salesDefaultPurchasePrice: p.sale?.defaultPurchasePrice ?? "",
    landedCost: p.sale?.landedCost ?? p.landedCost ?? "",

    types: {
      "Never Diminishing": !!p.types?.neverDiminishing,
      "Assembled Product": !!p.types?.assembledProduct,
      "Component Product": !!p.types?.componentProduct,
      "Obsolete": !!p.types?.obsolete,
      "Serialized": !!p.types?.serialized,
      "Batch Tracked": !!p.types?.batchTracked,
      "Sellable": !!p.types?.sellable,
      "Purchasable": !!p.types?.purchasable
    },

    units:
      (p.unitsOfMeasures || []).map((u) => ({
        id: u.id,                     // KEEP ID for update
        entity: u.entity || "",
        name: u.name || "",
        conversionRate:
          u.conversionRate === null || u.conversionRate === undefined
            ? ""
            : String(u.conversionRate),

        purchasable: !!u.purchasable, // backend = purchasable
        packSize: u.packSize ?? "",
        barcode: u.barcode ?? "",
        weight: u.weight ?? "",

        dimensions: {
          width: u.dimensionW ?? "",
          height: u.dimensionH ?? "",
          depth: u.dimensionD ?? ""
        }
      })) || []
  }));

  // -------- SALES PRICE TIERS --------
  setSalesTiers(
    (p.sale?.sellPriceTiers || []).map((t) => ({
      id: t.id,             // KEEP ID for update
      entity: t.entity || "",
      tier: t.tierName || "",  // backend field = tierName
      price: t.defaultSellPrice ?? "",
      minimumSellPrice:t.minimumSellPrice ?? "",
      landedCost: t.landedCost ?? "",
      // productCode: t.productCode || p.productCode || "",
      sku: t.sku || "",
      // description: t.description || "",
      commerceCode: t.commerceCode || "",          // NEW
      // customsDescription: t.customsDescription || "",
      active: t.active !== false  
    }))
  );
};


  const handleInput = (key, val) => {
  const nextValue = trimToFieldLimit(key, val);
  setForm((f) => ({ ...f, [key]: nextValue }));
  validateField(key, nextValue, setErrors); //  LIVE VALIDATION
};

  const handleTypeToggle = (type) =>
    setForm((f) => ({ ...f, types: { ...f.types, [type]: !f.types[type] } }));

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > MAX_IMAGE_SIZE_BYTES) {
      setImageUploadError("Maximum allowed image size is 3MB.");
      window.alert("Maximum allowed image size is 3MB.");
      e.target.value = null;
      return;
    }
    setImageUploadError("");
    setImage({ file, isChanged: true });
    setIsImageRemoved(false);
  };

  const openAddUnit = () => {
    setNewUnit({
      name: "",
      conversionRate: "",
      purchasable: true,
      packSize: "",
      barcode: "",
      weight: "",
      entity: "",
      dimensions: { width: "", height: "", depth: "" }
    });
    setUnitErrors({});
    setEditUnitIndex(null);
    setIsAddUnitOpen(true);
  };

  const validateUnit = (unit) => {
    const e = {};
    if (!unit.name?.trim()) {
      e.name = "Name is required.";
    }
    if (!unit.entity?.trim()) {
      e.entity = "Entity is required.";
    }
    const barcodeError = getFieldValidationError("barcode", unit.barcode);
    if (barcodeError) {
      e.barcode = barcodeError;
    }

    // if (!unit.packSize || Number(unit.packSize) === 0) {
    //   e.packSize = "Pack Size is required.";
    // }
    // if (!String(unit.barcode).trim()) e.barcode = "Barcode is required.";
    // if (String(unit.weight ?? "").trim() !== "" && Number(unit.weight) === 0) {
    //   e.weight = "Weight can't be zero.";
    // }
    setUnitErrors(e);
    return Object.keys(e).length === 0;
  };

 const onSaveUnit = () => {
  if (!validateUnit(newUnit)) return;
  const unitToSave = {
    ...newUnit,
    name: newUnit.name?.trim() || null,
    entity: newUnit.entity?.trim() || null,
    conversionRate: newUnit.conversionRate === "" ? null : newUnit.conversionRate,
    packSize: newUnit.packSize === "" ? null : newUnit.packSize,
    barcode: newUnit.barcode?.trim() === "" ? null : newUnit.barcode?.trim(),
    weight: newUnit.weight === "" ? null : newUnit.weight,
    dimensions: {
      width: newUnit.dimensions?.width === "" ? null : newUnit.dimensions?.width ?? null,
      height: newUnit.dimensions?.height === "" ? null : newUnit.dimensions?.height ?? null,
      depth: newUnit.dimensions?.depth === "" ? null : newUnit.dimensions?.depth ?? null
    }
  };

  if (editUnitIndex !== null) {
    // UPDATE existing unit — KEEP id
    setForm((f) => {
      const updated = [...f.units];
      updated[editUnitIndex] = { ...updated[editUnitIndex], ...unitToSave };
      return { ...f, units: updated };
    });
    setIsEditUnitOpen(false);
  } else {
    // CREATE new unit — no id
    setForm((f) => ({
      ...f,
      units: [...f.units, { ...unitToSave }]
    }));
    setIsAddUnitOpen(false);
  }

  setNewUnit({
    name: "",
    conversionRate: "",
    purchasable: true,
    packSize: "",
    barcode: "",
    weight: "",
    entity: "",
    dimensions: { width: "", height: "", depth: "" }
  });
  setUnitErrors({});
};


  const onEditUnit = (idx) => {
    setNewUnit({ ...form.units[idx], id: Number(form.units[idx].id) });
    setEditUnitIndex(idx);
    setIsEditUnitOpen(true);
  };

  const validateSalesTier = (t) => {
    const e = {};
    if (!t.entity?.trim()) e.entity = "Entity is required.";
    // if (!t.tier?.trim()) e.tier = "Tier is required.";
    if (t.price === "" || Number.isNaN(Number(t.price))) e.price = "Price is required and must be a number.";
    if (
  t.price !== "" &&
  t.minimumSellPrice !== "" &&
  Number(t.price) < Number(t.minimumSellPrice)
) {
  const msg1 = "Default Sell Price must be greater than Minimum Sell Price.";
  const msg="Minimum Sell Price must be lower than Default Sell Price."

  e.price = msg1;                // 👈 add here
  e.minimumSellPrice = msg;     // 👈 already there
}
    // if (!t.productCode?.trim()) e.productCode = "Product Code is required.";
    // if (!t.sku?.trim()) e.sku = "SKU is required.";
    // if (!t.description?.trim()) e.description = "Description is required.";
    setSalesTierErrors(e);
    return Object.keys(e).length === 0;
  };

  const onSaveSalesTier = () => {
    if (!validateSalesTier(newSalesTier)) return;
    if (editSalesTierIndex !== null) {
      const updated = [...salesTiers];
      updated[editSalesTierIndex] = {
  ...updated[editSalesTierIndex], // keep id
  ...newSalesTier
};
      setSalesTiers(updated);
      setEditSalesTierIndex(null);
      setIsEditSalesTierOpen(false);
    } else {
      setSalesTiers((s) => [...s, newSalesTier]);
      setIsAddSalesTierOpen(false);
    }
    setNewSalesTier({ entity: "", tier: "", price: "", landedCost: "", sku: "", commerceCode: "" ,minimumSellPrice:"", active: true });
    setSalesTierErrors({});
  };

  const onEditSalesTier = (i) => {
    setNewSalesTier(salesTiers[i]);
    setEditSalesTierIndex(i);
    setIsEditSalesTierOpen(true);
  };

const buildPayload = () => {
  const isBlank = (v) =>
    v === null ||
    v === undefined ||
    (typeof v === "string" && v.trim() === "");

  const toNumberOrNull = (v, { mustBePositive = false } = {}) => {
    if (isBlank(v)) return null;
    const n = Number(v);
    if (Number.isNaN(n)) return null;
    if (mustBePositive && n <= 0) return null;
    return n;
  };

  console.log(form.units);
  return {
    ...(isEditMode && { id: Number(id) }),

    productCode: trimText(form.productCode),
    productDescription: trimText(form.productDescription),

    productGroup: form.productGroup,
    productCategory: form.productCategory || null,
    purchaseAccount: form.purchaseAccount,
    sageSalesAccount: form.sageSalesAccount,


    active: true,
    // ONLY WHEN IMAGE IS REMOVED
    ...(isImageRemoved && { imageUrl: null }),

    template: {
      // productDefaultLabelQuantity: Number(form.productQty || null),
      salesOrderDefaultLabelQuantity: Number(form.salesQty) || null,
      purchaseOrdersDefaultLabelQuantity: Number(form.purchaseQty) || null
    },

    types: {
      neverDiminishing: !!form.types["Never Diminishing"],
      assembledProduct: !!form.types["Assembled Product"],
      componentProduct: !!form.types["Component Product"],
      obsolete: !!form.types["Obsolete"],
      serialized: !!form.types["Serialized"],
      batchTracked: !!form.types["Batch Tracked"],
      sellable: !!form.types["Sellable"],
      purchasable: !!form.types["Purchasable"]
    },

    notes: trimText(form.notes) || null,

    //  send reminders back using correct backend field name
    reminder: trimText(form.reminders) || null,

    addToSalesQuoteAndOrder: !!form.addToSales,
    addToPurchaseOrder: !!form.addToPurchase,
    comments: trimText(form.comments) || null,

    internationalAttributes: {
      countryOfOrigin: form.countryOfOrigin,
      supplementaryUnit:
        form.supplementaryUnit && form.supplementaryUnit.trim() !== ""
          ? form.supplementaryUnit.trim()
          : null,
      commerceCode:
        form.commerceCode && form.commerceCode.trim() !== ""
          ? form.commerceCode.trim()
          : null
    },

    unitsOfMeasures: (form.units || []).map((u) => ({
      // KEEP id only if editing existing
      ...(u.id ? { id: Number(u.id) } : {}),

      name: u.name?.trim() ? u.name.trim() : null,

      // null when empty
      conversionRate: toNumberOrNull(u.conversionRate),

      //  backend expects "purchasable", NOT "purchasable"
      purchasable: !!u.purchasable,
        entity: u.entity?.trim() ? u.entity.trim() : null,
      packSize: toNumberOrNull(u.packSize, { mustBePositive: true }),
      barcode: u.barcode?.trim() ? u.barcode.trim() : null,
      weight: toNumberOrNull(u.weight),
 

      //  send null instead of 0 when empty
      dimensionW: u.dimensions?.width ? Number(u.dimensions.width) : null,
      dimensionH: u.dimensions?.height ? Number(u.dimensions.height) : null,
      dimensionD: u.dimensions?.depth ? Number(u.dimensions.depth) : null
    })),
      
    sale: {
      defaultSellPrice: toNumberOrNull(form.salesDefaultSellPrice),
      minimumSellPrice: toNumberOrNull(form.salesMinSellPrice),
      minimumOrderQuantity: toNumberOrNull(form.salesMinSaleQty),
      defaultPurchasePrice: toNumberOrNull(form.salesDefaultPurchasePrice),
      landedCost: toNumberOrNull(form.landedCost),
      sellPriceTiers: (salesTiers || []).map((t) => ({
        // KEEP id only when exists
        ...(t.id ? { id: Number(t.id) } : {}),

        entity: t.entity,
        tierName: t.tier, // backend expects tierName
        defaultSellPrice: Number(t.price),
        landedCost: toNumberOrNull(t.landedCost),
        minimumSellPrice: toNumberOrNull(t.minimumSellPrice),
        sku: t.sku,
        description: t.description,
        active: t.active !== false, 
        commerceCode:
  t.commerceCode && t.commerceCode.trim() !== ""
    ? t.commerceCode.trim()
    : null,

// customsDescription:
//   t.customsDescription && t.customsDescription.trim() !== ""
//     ? t.customsDescription.trim()
//     : null,
      }
))    }
  };

};
const formatSellableWarnings = (details = []) => {
  const entityMap = {};

  details.forEach(d => {
    const msg = d.message || d;

    // extract entity like "INC", "APS"
    const entityMatch = msg.match(/in\s+"([^"]+)"/);
    const entity = entityMatch ? entityMatch[1] : null;

    if (!entity) return;

    if (!entityMap[entity]) {
      entityMap[entity] = {
        commerceCode: false,
        // customsDescription: false
      };
    }

    if (msg.toLowerCase().includes("commercecode")) {
      entityMap[entity].commerceCode = true;
    }

    // if (msg.toLowerCase().includes("customsdescription")) {
    //   entityMap[entity].customsDescription = true;
    // }
  });

  const lines = Object.entries(entityMap).map(
    ([entity, fields]) => {
      const missing = [];
      if (fields.commerceCode) missing.push("Commerce Code");
      // if (fields.customsDescription) missing.push("Customs Description");

      return `• ${entity}: ${missing.join(" and ")}`;
    }
  );

  if (!lines.length) return null;

  return (
    `Sales Tier information is incomplete.\n\n` +
    `Please fill the following fields:\n` +
    lines.join("\n")
  );
};
 



const handleSave = async () => {
  setErrors({});
  const isEdit = isEditMode && (id || editingProductFromState?.id);

  /* ----------------------------------------
     1) FRONTEND VALIDATION
  ---------------------------------------- */
  const localErrors = {};

  // Product tab required fields
  const productCodeError = getFieldValidationError("productCode", form.productCode);
  if (productCodeError) localErrors.productCode = productCodeError;
  const productDescriptionError = getFieldValidationError("productDescription", form.productDescription);
  if (productDescriptionError) localErrors.productDescription = productDescriptionError;
  const productCategoryError = getFieldValidationError("productCategory", form.productCategory);
  if (productCategoryError) localErrors.productCategory = productCategoryError;
  const notesError = getFieldValidationError("notes", form.notes);
  if (notesError) localErrors.notes = notesError;
  const remindersError = getFieldValidationError("reminders", form.reminders);
  if (remindersError) localErrors.reminders = remindersError;
  const commentsError = getFieldValidationError("comments", form.comments);
  if (commentsError) localErrors.comments = commentsError;
  const commerceCodeError = getFieldValidationError("commerceCode", form.commerceCode);
  if (commerceCodeError) localErrors["internationalAttributes.commerceCode"] = commerceCodeError;
  if (!form.countryOfOrigin?.trim())
    localErrors["internationalAttributes.countryOfOrigin"] = "Please select a Country Of Origin.";
// if (!form.purchaseAccount?.trim())
//    localErrors.purchaseAccount = "Please select Purchase Account.";

// if (!form.sageSalesAccount?.trim())
//    localErrors.sageSalesAccount = "Please select Xero Sales Account.";
 

  // All other fields are optional. Product Code is the only mandatory field.
  if (!salesTiers || salesTiers.length < 1) {
    localErrors["sale.sellPriceTiers"] = "Add atleast 1 Sale Price Tiers.";
  }
  if (
    String(form.salesMinSaleQty || "").trim() !== "" &&
    !/^\d+(\.\d{0,3})?$/.test(String(form.salesMinSaleQty))
  ) {
    localErrors["sale.minimumOrderQuantity"] =
      "Minimum sale quantity must be a valid decimal number.";
  }
  if (
    String(form.salesDefaultSellPrice || "").trim() !== "" &&
    String(form.salesMinSellPrice || "").trim() !== "" &&
    Number(form.salesDefaultSellPrice) < Number(form.salesMinSellPrice)
  ) {
    localErrors["sale.defaultSellPrice"] =
      "Default Sell Price cannot be lower than the Minimum Sell Price.";
    localErrors["sale.minimumSellPrice"] =
      "Default Sell Price cannot be lower than the Minimum Sell Price.";
  }
  /*
  // Sales tab validations
  if (
    form.salesDefaultSellPrice === "" ||
    Number.isNaN(Number(form.salesDefaultSellPrice))
  ) {
    localErrors["sale.defaultSellPrice"] = "Default sell price is required.";
  } else if (Number(form.salesDefaultSellPrice) <= 0) {
    localErrors["sale.defaultSellPrice"] = "Default sell price must be greater than 0.";
  }

  if (
    form.salesMinSellPrice === "" ||
    Number.isNaN(Number(form.salesMinSellPrice))
  ) {
    localErrors["sale.minimumSellPrice"] = "Minimum sell price is required.";
  } else if (Number(form.salesMinSellPrice) <= 0) {
    localErrors["sale.minimumSellPrice"] = "Minimum sell price must be greater than 0.";
  }

  if (
    form.salesMinSaleQty === "" ||
    Number.isNaN(Number(form.salesMinSaleQty))
  ) {
    localErrors["sale.minimumOrderQuantity"] = "Minimum sale quantity is required.";
  } else if (Number(form.salesMinSaleQty) <= 0) {
    localErrors["sale.minimumOrderQuantity"] = "Minimum sale quantity must be greater than 0.";
  }

  if (
    form.salesDefaultPurchasePrice === "" ||
    Number.isNaN(Number(form.salesDefaultPurchasePrice))
  ) {
    localErrors["sale.defaultPurchasePrice"] = "Default purchase price is required.";
  } else if (Number(form.salesDefaultPurchasePrice) <= 0) {
    localErrors["sale.defaultPurchasePrice"] = "Default purchase price must be greater than 0.";
  }

  // if (!salesTiers || salesTiers.length < 1) {
  //   localErrors["sale.sellPriceTiers"] = "Add atleast 1 Sale Price Tiers.";
  // }
  */

  /* ----------------------------------------
     2) AUTO SWITCH TAB BASED ON ERRORS
  ---------------------------------------- */
  const salesTabKeys = [
    "sale.defaultSellPrice",
    "sale.minimumSellPrice",
    "sale.minimumOrderQuantity",
    "sale.defaultPurchasePrice",
    "sale.sellPriceTiers"
  ];

  const hasSalesErrors = Object.keys(localErrors).some((k) => salesTabKeys.includes(k));
  setActiveTab(hasSalesErrors ? "Entity Details" : "Generic Details");

  if (Object.keys(localErrors).length > 0) {
    setErrors(localErrors);
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }

  /* ----------------------------------------
     3) BUILD PAYLOAD
  ---------------------------------------- */
  const payloadObj = buildPayload();

  /* ----------------------------------------
     4) BUILD FORMDATA (JSON + IMAGE)
  ---------------------------------------- */
  const fd = new FormData();

  // JSON as Blob (correct way for backend)
  // fd.append(
  //   "product",
  //   new Blob([JSON.stringify(payloadObj)], { type: "application/json" })
  // );
  fd.append("product", JSON.stringify(payloadObj));
  // Image if uploaded
  // IMAGE HANDLING
 if (image.isChanged && image.file) {
  fd.append("image", image.file);
}


  /* ----------------------------------------
     5) SEND ONLY ONE REQUEST
  ---------------------------------------- */
  try {
    if (!isEdit) {
      // CREATE
      await axios.post(`/product`, fd, {
        headers: { "Content-Type": "multipart/form-data" }
      });
    } else {
      // UPDATE
      await axios.put(`/product/${id}`, fd, {
        headers: { "Content-Type": "multipart/form-data" }
      });
    }
    //RESET REMOVE FLAG AFTER SUCCESS
  setIsImageRemoved(false);
    alert(" Product saved successfully!");
    navigate("/products");

  } catch (err) {
    console.error("Save error:", err.response?.data || err);

    const backend = err.response?.data;
    const mapped = {};
    if (
      backend?.code === "UNIQUE_CONSTRAINT_ERROR" &&
      /productcode/i.test(String(backend?.message || ""))
    ) {
      mapped.productCode = "Product Code already exists.";
    }
//     if (backend?.code === "UNIQUE_CONSTRAINT_ERROR") {
//   mapped["productCode"] = "Product Code must be unique. This code already exists.";
// }
    // Joi / express-validator style errors
    // Handle Sequelize unique constraint per field
if (Array.isArray(backend?.details)) {
  backend.details.forEach(({ path, message }) => {
    let mappedKey = path;

    //  FIX: map unique constraint id → productCode
    if (path && typeof path === "string" && path.startsWith("UQ__products")) {
      mappedKey = "productCode";
      message = "Product Code must be unique. This code already exists.";
    }

    const fieldMap = {
      entityId: "sale.sellPriceTiers",
      productCode: "productCode"
    };

    mappedKey = fieldMap[mappedKey] || mappedKey;
    mapped[mappedKey] = message;
  });
}
if (Array.isArray(backend?.details) && backend.details.length > 0) {
  const friendlyMessage = formatSellableWarnings(backend.details);

  if (friendlyMessage) {
    alert(friendlyMessage);
  } else {
    // fallback (other backend validations)
    const messages = backend.details.map(d => d.message || JSON.stringify(d));
    alert(messages.join("\n"));
  }
}

 if (Array.isArray(backend?.errors)) {
  backend.errors.forEach((e) => {
    let key = e.path;

    // Map Sequelize DB field → React Form field
    const fieldMap = {
      supplementaryUnit: "internationalAttributes.supplementaryUnit",
      commerceCode: "internationalAttributes.commerceCode",
      // customsDescription: "internationalAttributes.customsDescription",
      countryOfOrigin: "internationalAttributes.countryOfOrigin"
    };

    if (fieldMap[key]) key = fieldMap[key];
    if (e.validatorKey === "len") {
  mapped[key] = "Supplementary Unit must not be empty.";
}

    mapped[key] = e.message || "Invalid value";
  });
}





    // Generic backend messages like ["field: message"]
    if (Array.isArray(backend?.details)) {
  backend.details.forEach((d) => {
    // If "d" is a string → parse normally
    if (typeof d === "string") {
      const key = d.includes(":") ? d.split(":")[0] : "general";
      mapped[key] = d;
    }

    // If backend sent an object → use its fields
    else if (typeof d === "object" && d !== null) {
      const key = d.path || d.field || "general";
      mapped[key] = d.message || JSON.stringify(d);
    }
  });
}
if (backend?.message && !backend?.errors && !backend?.details) {
  mapped["general"] = backend.message;
}
    setErrors((prev) => ({ ...prev, ...mapped }));
  }
};

useEffect(() => {
  if (!image?.file) {
    setPreviewUrl(null);
    return;
  }
  const url = URL.createObjectURL(image.file);
  setPreviewUrl(url);
  return () => {
    URL.revokeObjectURL(url);
    setPreviewUrl(null);
  };
}, [image?.file]);

  const handleReset = () => {
    setImageUploadError("");
    if (isEditMode) {
    // Edit Product → reload original auto-filled data
// Reload the same edit product page to restore original auto-filled data
    window.location.reload();  } else {
    // Add Product → clear all fields
    setForm({
      productCode: "",
      productDescription: "",

      productGroup: "",
      productCategory: "",
      productSubGroup: "",
      productBrand: "",

      // productQty: "",
      salesQty: "",
      purchaseQty: "",

      
      countryOfOrigin: "",
      supplementaryUnit: "",
      commerceCode: "",

      notes: "",
      reminders: "",
      comments: "",
      addToSales: false,
      addToPurchase: false,

      salesDefaultSellPrice: "",
      salesMinSellPrice: "",
      salesMinSaleQty: "",
      salesDefaultPurchasePrice: "",
      landedCost: "",

      types: TYPE_LIST.reduce((o, t) => ({ ...o, [t]: false }), {}),

      units: []
    });

    setImage({ file: null, isChanged: false });
    setSalesTiers([]);
    setErrors({});
  
   } };
// Live validation helper
const validateField = (key, value, setter) => {
  const fieldErrors = {};

  switch (key) {
    case "productCode":
      fieldErrors[key] = getFieldValidationError("productCode", value);
      break;

    case "productDescription":
      fieldErrors[key] = getFieldValidationError("productDescription", value);
      break;

    case "productCategory":
      fieldErrors[key] = getFieldValidationError("productCategory", value);
      break;

    case "notes":
      fieldErrors[key] = getFieldValidationError("notes", value);
      break;

    case "reminders":
      fieldErrors[key] = getFieldValidationError("reminders", value);
      break;

    case "comments":
      fieldErrors[key] = getFieldValidationError("comments", value);
      break;

    case "commerceCode":
      fieldErrors["internationalAttributes.commerceCode"] = getFieldValidationError("commerceCode", value);
      break;

    case "countryOfOrigin":
      if (!value.trim()) fieldErrors["internationalAttributes.countryOfOrigin"] =
        "Please select a Country Of Origin.";
      break;

    /*

    case "salesDefaultSellPrice":
      if (value === "" || Number.isNaN(Number(value)))
        fieldErrors["sale.defaultSellPrice"] = "Default sell price is required.";
      else if (Number(value) <= 0)
        fieldErrors["sale.defaultSellPrice"] = "Default sell price must be greater than 0.";
      break;

    case "salesMinSellPrice":
      if (value === "" || Number.isNaN(Number(value)))
        fieldErrors["sale.minimumSellPrice"] = "Minimum sell price is required.";
      else if (Number(value) <= 0)
        fieldErrors["sale.minimumSellPrice"] = "Minimum sell price must be greater than 0.";
      break;

    case "salesMinSaleQty":
      if (value !== "" && Number.isNaN(Number(value)))
        fieldErrors["sale.minimumOrderQuantity"] = "Minimum sale quantity must be a valid decimal number.";
      break;

    case "salesDefaultPurchasePrice":
      if (value === "" || Number.isNaN(Number(value)))
        fieldErrors["sale.defaultPurchasePrice"] = "Default purchase price is required.";
      else if (Number(value) <= 0)
        fieldErrors["sale.defaultPurchasePrice"] = "Default purchase price must be greater than 0.";
      break;
    */

    default:
      break;
  }

  setter((prev) => {
    const next = { ...prev, ...fieldErrors };
    Object.keys(next).forEach((errorKey) => {
      if (!next[errorKey]) delete next[errorKey];
    });
    return next;
  });

  // remove the error if fixed
  if (Object.keys(fieldErrors).length === 0) {
    setter((prev) => {
      const newErr = { ...prev };
      delete newErr[key];
      delete newErr["internationalAttributes.commerceCode"];
      delete newErr["internationalAttributes.countryOfOrigin"];
      delete newErr["internationalAttributes.supplementaryUnit"];
      delete newErr["sale.defaultSellPrice"];
      delete newErr["sale.minimumSellPrice"];
      delete newErr["sale.minimumOrderQuantity"];
      delete newErr["sale.defaultPurchasePrice"];
      return newErr;
    });
  }
};
const onDeleteUnit = (idx) => {
  setDeleteType("unit");
  setDeleteTarget(idx);
  setIsDeleteConfirmOpen(true);
};

const onDeleteSalesTier = (idx) => {
  setDeleteType("tier");
  setDeleteTarget(idx);
  setIsDeleteConfirmOpen(true);
};

const performDelete = () => {
  if (deleteType === "unit") {
    setForm((f) => ({
      ...f,
      units: f.units.filter((_, i) => i !== deleteTarget)
    }));
  }

  if (deleteType === "tier") {
    setSalesTiers((s) => s.filter((_, i) => i !== deleteTarget));
  }

  setIsDeleteConfirmOpen(false);
  setDeleteTarget(null);
  setDeleteType(null);
};

const handleNumberInput = (key, val) => {
  // allow empty
  if (val === "") {
    handleInput(key, "");
    return;
  }

  // allow only digits (no decimals, no minus)
  if (/^\d+$/.test(val)) {

    //  trim to max 12 digits
    const trimmed = val.length > 12 ? val.slice(0, 12) : val;

    handleInput(key, trimmed);
    return;
  }
};



const handleUnitNumberInput = (key, val) => {
  // allow empty
  if (val === "") {
    setNewUnit((u) => ({ ...u, [key]: "" }));
    return;
  }

  if (!/^\d{1,12}(\.\d{0,3})?$/.test(val)) return;

  setNewUnit((u) => ({ ...u, [key]: val }));
};
const handleSalesDecimalInput = (key, val) => {
  if (key === "salesMinSaleQty") {
    if (val === "") {
      handleInput(key, "");
      setErrors((prev) => {
        const next = { ...prev };
        delete next["sale.minimumOrderQuantity"];
        return next;
      });
      return;
    }

    if (!/^\d{1,12}(\.\d{0,3})?$/.test(val)) return;
    handleInput(key, val);
    setErrors((prev) => {
      const next = { ...prev };
      delete next["sale.minimumOrderQuantity"];
      return next;
    });
    return;
  }

  // remove commas and spaces added by formatter
  const raw = val.replace(/,/g, "");

  if (raw === "") {
    handleInput(key, "");
    if (key === "salesDefaultSellPrice" || key === "salesMinSellPrice") {
      const nextDefaultSellPrice =
        key === "salesDefaultSellPrice" ? "" : form.salesDefaultSellPrice;
      const nextMinimumSellPrice =
        key === "salesMinSellPrice" ? "" : form.salesMinSellPrice;

      syncSellPriceValidation(nextDefaultSellPrice, nextMinimumSellPrice);
    }
    return;
  }

  // allow digits + one decimal point
  if (!/^\d*\.?\d*$/.test(raw)) return;

  // limit to 12 digits total (excluding dot)
  const digitsOnly = raw.replace(/\./g, "");
  if (digitsOnly.length > 12) return;

  handleInput(key, raw);
  if (key === "salesDefaultSellPrice" || key === "salesMinSellPrice") {
    const nextDefaultSellPrice =
      key === "salesDefaultSellPrice" ? raw : form.salesDefaultSellPrice;
    const nextMinimumSellPrice =
      key === "salesMinSellPrice" ? raw : form.salesMinSellPrice;

    syncSellPriceValidation(nextDefaultSellPrice, nextMinimumSellPrice);
  }
};

const handleDecimalInput = (key, val) => {
  if (val === "") {
    handleInput(key, "");
    return;
  }

  if (/^\d+(\.\d{0,3})?$/.test(val)) {
    handleInput(key, val);
    return;
  }
};
const handleConversionRateInput = (val) => {
  // allow empty
  if (val === "") {
    setNewUnit((u) => ({ ...u, conversionRate: "" }));
    setUnitErrors((e) => ({ ...e, conversionRate: null }));
    return;
  }

  // allow numbers up to 12 digits + optional decimal
  const regex = /^\d{1,12}(\.\d{0,3})?$/;
  if (!regex.test(val)) return;

  // HARD LIMIT: max 100 allowed
  if (Number(val) > 100) {
    setUnitErrors((e) => ({
      ...e,
      conversionRate: "Conversion rate must not exceed 100%"
    }));
    return;
  }

  // Clear error if valid
  setUnitErrors((e) => ({ ...e, conversionRate: null }));

  setNewUnit((u) => ({ ...u, conversionRate: val }));
};



const handleDimensionNumberInput = (dimKey, val) => {
  // Allow empty
  if (val === "") {
    setNewUnit((u) => ({
      ...u,
      dimensions: { ...u.dimensions, [dimKey]: "" }
    }));
    return;
  }

  // Regex → 12 digits before decimal, 3 digits after
  const regex = /^\d{1,12}(\.\d{0,3})?$/;

  if (!regex.test(val)) return;

  setNewUnit((u) => ({
    ...u,
    dimensions: { ...u.dimensions, [dimKey]: val }
  }));
};





const handleUnitDecimalInput = (key, val) => {
  if (val === "") {
    setNewUnit((u) => ({ ...u, [key]: "" }));
    if (key === "weight") {
      setUnitErrors((e) => ({ ...e, weight: null }));
    }
    return;
  }

  // Allow 0, natural numbers and decimals.
  const regex = /^\d{1,12}(\.\d{0,12})?$/;
  if (!regex.test(val)) return;

  setNewUnit((u) => ({ ...u, [key]: val }));

  if (key === "weight") {
    const isZeroValue = /^0(?:\.0+)?$/.test(val);
    setUnitErrors((e) => ({
      ...e,
      weight: isZeroValue ? "Weight can't be zero." : null
    }));
  }
};

// prevent leading space for strings
const blockLeadingSpace = (val) => {
  if (val.length === 1 && val === " ") return false;
  return true;
};

// Validate numeric (non-negative, 12 digits before decimal, 3 after)
const validateTierPrice = (val) => {
  return /^\d{1,12}(\.\d{0,3})?$/.test(val);
};

// Validate 255-character max strings
const validateString255 = (val) => {
  return val.length <= 255;
};

const usedEntities = React.useMemo(() => {
  return new Set(salesTiers.map(t => t.entity));
}, [salesTiers]);

const availableEntityOptions = React.useMemo(() => {
  // ADD MODE → exclude all used entities
  if (isAddSalesTierOpen) {
    return entityOptions.filter(e => !usedEntities.has(e));
  }

  // EDIT MODE → allow current entity + unused ones
  if (isEditSalesTierOpen) {
    return entityOptions.filter(
      e => e === newSalesTier.entity || !usedEntities.has(e)
    );
  }

  return entityOptions;
}, [
  entityOptions,
  usedEntities,
  isAddSalesTierOpen,
  isEditSalesTierOpen,
  newSalesTier.entity
]);

const resetSalesTierForm = () => {
  setNewSalesTier({
    entity: "",
    tier: "",
    price: "",
    landedCost: "",
    sku: "",
    // description: "",
    commerceCode: "",
    // customsDescription: "",
    minimumSellPrice:"",
    active: true,
  });
  setSalesTierErrors({});
  setEditSalesTierIndex(null);
};

  return (
    (isDropdownLoading || isProductLoading) ? (
      <div style={{ minHeight: "50vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
          <Spin indicator={<LoadingOutlined style={{ fontSize: 34, color: "#f50087" }} spin />} />
          <span style={{ color: "#f50087", fontWeight: 600 }}>Loading</span>
        </div>
      </div>
    ) : (
    <div className="anp-container">
      <div className="anp-main">
        <div className="anp-breadcrumb-row">
        <Breadcrumbs/>
        {/* <h2 className="anp-main-h2-title"> {isEditMode ? "Edit Product" : "Add New Product"} */}
          <span className="anp-reset-text" onClick={handleReset}>Reset</span>
        {/* </h2> */}
        {/* <p>{isEditMode ? "Update product details" : "Create a new product with comprehensive details"}</p> */}
      </div>
        <div className="anp-content-row">
          <div className="anp-left">
            <div className="anp-card anp-card-with-tabs">
              <div className="anp-tabs" style={{ marginBottom: "2px", fontSize:"14px", fontWeight:"500",lineHeight:"20px", letterSpacing:"0%" }}>
                <Segmented
                  options={["Generic Details", "Entity Details"]}
                  value={activeTab}
                  onChange={setActiveTab}
                />
                {isEditMode && editEntitySummary && (
                  <span className="anp-entity-tab-label" title={editEntitySummary}>
                    Entities: {editEntitySummary}
                  </span>
                )}
              </div>

              {activeTab === "Generic Details" && (
                <div className="anp-tab-content">
                  <h3>Generic Details</h3>

                  <div className="anp-row">
                    <div className="anp-group">
                      <label>
                        Product Code <span className="required-asterisk">*</span>
                        <InfoTooltip message="Unique identifier for this product." />
                      </label>
                      <input
                        type="text"
                        value={form.productCode}
                        maxLength={PRODUCT_FIELD_LIMITS.productCode}
                        placeholder="Enter Product Code (e.g., P001)"
                        disabled={isEditMode}   // THIS makes it read-only during editing
  style={isEditMode ? { backgroundColor: "#f3f3f3", cursor: "not-allowed" } : {}}
  onChange={(e) => {
    if (isEditMode) return; // Block typing in edit mode (safety)
    const val = sanitizeNoLeadingSpaces(e.target.value);
    handleInput("productCode", val);
    validateField("productCode", val, setErrors);
                      }}
                      />
                      {errors["productCode"] && <p className="error-msg">{errors["productCode"]}</p>}
                    </div>
                    <div className="anp-group">
                      <label>
                        Product Group
                        <InfoTooltip message="Select the main classification for this product." />
                      </label>
                      <CustomSelect
  value={form.productGroup}
  onChange={(v) => handleInput("productGroup", v)}
  options={apiGroups.map(g => g.value)}
  placeholder="Select Product Group"
  width="100%"
/>

                      {errors["productGroup"] && <p className="error-msg">{errors["productGroup"]}</p>}
                    </div>
                  </div>

                  <div className="anp-group">
                    <label className="anp-group-product-description">
                      Product Description
                      <span className="required-asterisk">*</span>
                      <InfoTooltip message="Provide a detailed description of the product." />
                    </label>
                    <textarea rows={3} maxLength={PRODUCT_FIELD_LIMITS.productDescription} value={form.productDescription} placeholder="Enter Product Description" onChange={(e) => handleInput("productDescription", e.target.value)} />
                    {errors["productDescription"] && <p className="error-msg">{errors["productDescription"]}</p>}
                  </div>

                  <div className="anp-row">
                    <div className="anp-group anp-group-half">
                      <label>
                        Product Category
                        <InfoTooltip message="Select the product category (optional)." />
                      </label>
                      <CustomSelect
  value={form.productCategory}
  onChange={(v) => handleInput("productCategory", v)}
  options={productCategoryOptions.map((c) => c.value)}
  placeholder="Select Product Category"
  width="100%"
/>
                    </div>

                    <div className="anp-group anp-group-half">
                      <label>
                        Minimum Order Quantity
                        <InfoTooltip message="Enter the minimum order quantity for this product." />
                      </label>
                      <input
                        type="text"
                        value={form.salesMinSaleQty}
                        placeholder="Enter Minimum Order Qty"
                        onChange={(e) => handleSalesDecimalInput("salesMinSaleQty", e.target.value)}
                      />
                      {errors["sale.minimumOrderQuantity"] && <p className="error-msg">{errors["sale.minimumOrderQuantity"]}</p>}
                    </div>
                  </div>

                  <div className="anp-row">
                    <div className="anp-group">
                        <label>
                          Purchase Account
                          <InfoTooltip message="Select Purchase Account." />
                        </label>
                        <CustomSelect
                          value={form.purchaseAccount}
                          onChange={(v) => handleInput("purchaseAccount", v)}
                          options={purchaseAccounts.map(a => a.value)}
                          placeholder="Select Purchase Account"
                        />
                        {errors["purchaseAccount"] && <p className="error-msg">{errors["purchaseAccount"]}</p>}
                      </div>

                    <div className="anp-group">
                          <label>
                            Sage Sales Account
                            <InfoTooltip message="Select Sage Sales Account." />
                          </label>
                          <CustomSelect
                              value={form.sageSalesAccount}
                              onChange={(v) => handleInput("sageSalesAccount", v)}
                              options={salesAccounts}
                              placeholder="Select Sage Sales Account"
                            />
                          {errors["sageSalesAccount"] && <p className="error-msg">{errors["sageSalesAccount"]}</p>}
                        </div>
                  </div>

                  {/* Default Label Quantity / Sales Orders Quantity / Purchase Orders Quantity hidden as requested */}

                  <h3>International Commerce Attributes</h3>
                  <div className="anp-row">
                    <div className="anp-group">
                      <label>Country of Origin <span className="required-asterisk">*</span>
                        <InfoTooltip message="Select the country where this product originated." />
                      </label>
                      <CustomSelect
                        value={form.countryOfOrigin}
                        onChange={(v) => handleInput("countryOfOrigin", v)}
                        options={countries}
                        placeholder="Select Origin"
                        width="100%"
                      />


                      {errors["internationalAttributes.countryOfOrigin"] && <p className="error-msg">{errors["internationalAttributes.countryOfOrigin"]}</p>}
                    </div>

                    <div className="anp-group">
                      <label>Supplementary Unit
                        <InfoTooltip message="Select the supplementary unit for this product." />
                      </label>
                      <CustomSelect
  value={form.supplementaryUnit}
  onChange={(v) => handleInput("supplementaryUnit", v)}
  options={SUPPLEMENTARY_UNIT_OPTIONS}
  placeholder="Select Unit"
  width="100%"
/>

                      {errors["internationalAttributes.supplementaryUnit"] && <p className="error-msg">{errors["internationalAttributes.supplementaryUnit"]}</p>}
                    </div>
                  </div>
                  <div className="anp-row">
                    <div className="anp-group anp-group-half">
                      <label>Commerce Code <span className="required-asterisk">*</span>
                        <InfoTooltip message="Enter international commerce code." />
                      </label>
                      <input
                        type="text"
                        maxLength={PRODUCT_FIELD_LIMITS.commerceCode}
                        value={form.commerceCode}
                        onChange={(e) => handleInput("commerceCode", sanitizeNoLeadingSpaces(e.target.value))}
                        placeholder="Enter Commerce Code"
                      />
                      {errors["internationalAttributes.commerceCode"] && <p className="error-msg">{errors["internationalAttributes.commerceCode"]}</p>}
                    </div>
                  </div>

                  <div className="units-header">
                    <h3>Units of Measure 
                      <InfoTooltip message="Manage the units of measure for this product." />
                    </h3>
                    <button type="button" className="add-unit-link" onClick={openAddUnit}>
                      + Add Unit
                    </button>
                  </div>

                  <div className="units-scroll-wrapper">
                    <table className="units-table">
                      <thead>
                        <tr >
                          <th style={{ textAlign: "center" }}>Name</th>
                          <th style={{ textAlign:"center"}} >Entity</th>
                          <th style={{ textAlign: "center" }}>Conversion Rate</th>
                          <th style={{ textAlign: "center" }}>Purchasable</th>
                          <th style={{ textAlign: "center" }}>Pack Size</th>
                          <th style={{ textAlign: "center" }}>Barcode</th>
                          <th style={{ textAlign: "center" }}>Weight</th>
                          <th style={{ textAlign: "center" }}>Dimensions</th>
                          <th style={{ textAlign: "center" }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {form.units && form.units.length > 0 ? (
                          form.units.map((u, idx) => (
                            <tr key={idx}>
                              <td style={{textAlign: "left"}}>{u.name || "-"}</td>
                              <td>{u.entity || "-"}</td>
                              <td style={{textAlign: "right"}}>{u.conversionRate || "-"}</td>
                              <td style={{textAlign: "left"}}>{u.purchasable ? "Yes" : "No"}</td>
                              <td style={{textAlign: "right"}}>{u.packSize || "-"}</td>
                              <td style={{textAlign: "left"}}>{u.barcode || "-"}</td>
                              <td style={{textAlign: "right"}}>{u.weight || "-"}</td>
                              <td style={{textAlign: "right"}}>{u.dimensions ? `${u.dimensions.width|| "-"}×${u.dimensions.height || "-"}×${u.dimensions.depth || "-"}` : "-"}</td>
                              <td className="anp-actins">
                                <button className="edit-icon-btn" style={{width:"32px", height:"32px"}} onClick={() => onEditUnit(idx)}>
  <img src={editIcon} alt="Edit" className="edit-icon" />
</button>

<button className="delete-icon-btn" onClick={() => onDeleteUnit(idx)}>
  <img src={deleteIcon} alt="Delete" className="delete-icon" />
</button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr className="units-placeholder-row">
                            <td colSpan={9} style={{ textAlign: "center", color: "#7509B8" }}>No units added yet</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {errors["unitsOfMeasures"] && <p className="error-msg">{errors["unitsOfMeasures"]}</p>}

                <h3 style={{ marginBottom: "8px" }}>Product Image
                  <InfoTooltip message="Upload or edit the product image." />
                </h3>

{/* ADD MODE — SHOW UPLOAD BOX */}
{!image.file && !previewUrl && !finalImageUrl ? (
    <div className="anp-upload-large">
    <input
      type="file"
      accept=".png,.jpg,.jpeg"
      id="image-upload"
      className="anp-hidden-file-input"
      onChange={handleImageChange}
    />

    <label htmlFor="image-upload" className="anp-upload-large-label">
      <img src={uploadIcon} alt="upload" className="anp-upload-large-icon" />
      <p>Click to upload or drag & drop</p>
      <span>PNG, JPG, JPEG (max 3MB each)</span>
    </label>
    {imageUploadError && <p className="error-msg">{imageUploadError}</p>}
  </div>
) : (
  /* EDIT MODE — SHOW IMAGE + EDIT BUTTON */
  <div className="anp-image-wrapper">
 {/* image preview + edit button */}
{/* <img
  className="anp-product-image"
   src={
    imgError
      ? "/error-loading.jpg"
      : previewUrl
      ? previewUrl
      : finalImageUrl
        ? (finalImageUrl.startsWith("https")
            ? finalImageUrl
            : getProductImageUrl(id))
      : "/no-image.jpg"
  }
//   src={
//   previewUrl
//     ? previewUrl
//      : editingProductFromState?.id
//     ? editingProductFromState.imageUrl
//     : "/no-image.jpg"
// }

  alt="Product"
   onError={() => setImgError(true)}
/> */}
<img
  className="anp-product-image"
  src={imageSrc}
  alt="Product"
  onError={(e) => {
    e.currentTarget.onerror = null;
    setImageSrc("/no-image.jpg");
  }}
/>


<div className="anp-image-action-buttons">
<label htmlFor="image-upload-edit" className="anp-edit-image-btn">
  <img src={editIcon} alt="edit" />
</label>
<button
  type="button"
  className="anp-remove-image-btn"
  onClick={() => {
    setImage({ file: null, isChanged: false });
    setPreviewUrl(null);
    setFinalImageUrl(null);
    setIsImageRemoved(true);  // <-- NEW
    setImgError(false);
    setImageUploadError("");
  }}
>
  
</button></div>

{/* ADD MODE INPUT */}
<input
  id="image-upload-add"
  type="file"
  accept=".png,.jpg,.jpeg"
  className="anp-hidden-file-input"
  onClick={(e) => (e.target.value = null)}        // <-- NEW
  onChange={handleImageChange}
/>

{/* EDIT MODE INPUT */}
<input
  id="image-upload-edit"
  type="file"
  accept=".png,.jpg,.jpeg"
  className="anp-hidden-file-input"
  onClick={(e) => (e.target.value = null)}        // <-- NEW
  onChange={handleImageChange}
/>

{imageUploadError && <p className="error-msg">{imageUploadError}</p>}

  </div>
)}

                </div>
              )}

              {activeTab === "Entity Details" && (
                <div className="anp-tab-content">
                  <h3>Entity Details</h3>

                  {/* <div className="anp-row">
                    <div className="anp-group anp-group-half">
                      <label className="label-with-tooltip">
                          Default Sell Price
                          <InfoTooltip message="Default Product Price is equivalent to RRP." />
                         
                        </label>

                      <input type="text" value={formatMoneyLoose(form.salesDefaultSellPrice)} placeholder="Enter Default Sell Price" 
                     onChange={(e) => handleSalesDecimalInput("salesDefaultSellPrice", e.target.value)} />
                      {errors["sale.defaultSellPrice"] && <p className="error-msg">{errors["sale.defaultSellPrice"]}</p>}
                    </div>

                    <div className="anp-group anp-group-half">
                      <label>Minimum Sell Price
                      <InfoTooltip message="Enter the minimum sell price for this product." />
                      </label>
                      <input type="text" value={formatMoneyLoose(form.salesMinSellPrice)} placeholder="Enter Minimum Sell Price" 
                     onChange={(e) => handleSalesDecimalInput("salesMinSellPrice", e.target.value)} />
                      {errors["sale.minimumSellPrice"] && <p className="error-msg">{errors["sale.minimumSellPrice"]}</p>}
                    </div>
                  </div> */}

                  <div className="anp-row">
                    <div className="anp-group anp-group-half">
                      <label>
                        Default Purchase Price
                        <InfoTooltip message="Enter the default purchase price for this product." />
                      </label>
                      <div className="price-input-wrapper sale-price-input-wrapper">
                        <span className="currency-prefix sale-price-prefix">{"\u00A3"}</span>
                        <input
                          type="text"
                          value={formatMoneyLoose(form.salesDefaultPurchasePrice)}
                          placeholder="0"
                          className="with-prefix sale-price-input"
                          onChange={(e) => handleSalesDecimalInput("salesDefaultPurchasePrice", e.target.value)}
                        />
                      </div>
                      {errors["sale.defaultPurchasePrice"] && <p className="error-msg">{errors["sale.defaultPurchasePrice"]}</p>}
                    </div>
                  </div>

                  <div className="sales-tier-header">
                    <h3>Sale Price Tiers <span className="required-asterisk">*</span>
                      <InfoTooltip message="Define different sales price tiers for various entities." />
                    </h3>
                    <button
  className="add-sales-tier-link"
  onClick={() => {
    resetSalesTierForm();          
    setIsAddSalesTierOpen(true);   
  }}
>
  + Add Sales Price Tier
</button>
                  </div>
<div className="sales-price-tier-table-wrapper">
                  <table className="sales-price-tier-table">
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>Entity</th>
                        {/* <th>Tier</th> */}
                        <th style={{ textAlign: "center" }}>Default Sell Price</th>
                        <th style={{ textAlign: "center" }}>Minimum Sell Price</th>
                        {/* <th>Product Code</th> */}
                        {/* <th style={{ textAlign: "center" }}>SKU</th>
                        <th style={{ textAlign: "center" }}>Description</th>
                        <th style={{ textAlign: "center" }}>Commerce Code</th>
                        <th style={{ textAlign: "center" }}>
                          <CustomTooltip message="Customs Description" color="#7509B8">
                            <span style={{ cursor: "help" }}>
                              Customs Description
                            </span>
                          </CustomTooltip>
                        </th> */}
                        <th style={{ textAlign: "center" }}>Landed Cost</th>
                        
                        <th style={{ textAlign: "center" }}>Active</th>  
                        <th className="sales-tier-actions-col" style={{ textAlign: "center" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {salesTiers.length === 0 ? (
                        <tr>
                          <td colSpan="4" style={{ textAlign: "center", color: "#888" }}>-</td>
                        </tr>
                      ) : (
                        salesTiers.map((t, i) => (
                          <tr key={i}>
                            <td style={{textAlign: "left"}}>{t.entity}</td>
                            {/* <td>{t.tier}</td> */}
                           <td style={{textAlign: "right"}}>
                            {currencyMap?.[t.entity] ?? ""} {formatMoney(t.price)}
                          </td>
                          <td style={{textAlign: "right"}}>
                            {currencyMap?.[t.entity] ?? ""} {formatMoney(t.minimumSellPrice)}
                          </td>
                          <td style={{textAlign: "right"}}>
                            {t.landedCost !== "" && t.landedCost !== null && t.landedCost !== undefined
                              ? `${currencyMap?.[t.entity] ?? ""} ${formatMoney(t.landedCost)}`
                              : "-"}
                          </td>
                            {/* <td>{t.productCode || "-"}</td> */}
                            {/* <td style={{textAlign: "left"}}>{t.sku || "-"}</td> 
                            <td style={{textAlign: "left"}}>{t.description || "-"}</td>
                            <td style={{textAlign: "left"}}>{t.commerceCode || "-"}</td>
                            <td style={{textAlign: "left"}}>{t.customsDescription || "-"}</td> */}
                              {/* <td style={{ textAlign: "left" }}>
                                {t.sku ? (
                                  <CustomTooltip message={t.sku}>
                                    <span className="ellipsis-cell">{t.sku}</span>
                                  </CustomTooltip>
                                ) : "-"}
                              </td>

                              <td style={{ textAlign: "left" }}>
                                {t.description ? (
                                  <CustomTooltip message={t.description}>
                                    <span className="ellipsis-cell">{t.description}</span>
                                  </CustomTooltip>
                                ) : "-"}
                              </td>

                              <td style={{ textAlign: "left" }}>
                                {t.commerceCode ? (
                                  <CustomTooltip message={t.commerceCode}>
                                    <span className="ellipsis-cell">{t.commerceCode}</span>
                                  </CustomTooltip>
                                ) : "-"}
                              </td>

                              <td style={{ textAlign: "left" }}>
                                {t.customsDescription ? (
                                  <CustomTooltip message={t.customsDescription}>
                                    <span className="ellipsis-cell">{t.customsDescription}</span>
                                  </CustomTooltip>
                                ) : "-"}
                              </td> */}

                            <td style={{ textAlign: "center" }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "8px"
                                }}
                              >
                                <label className="switch">
                                  <input
                                    type="checkbox"
                                    checked={t.active}
                                    onChange={() => {
                                      const updated = [...salesTiers];
                                      updated[i] = { ...updated[i], active: !updated[i].active };
                                      setSalesTiers(updated);
                                    }}
                                  />
                                  <span className="slider round" />
                                </label>

                                <span
                                  // style={{
                                  //   fontSize: "14px",
                                  //   color: t.active ? "#7509B8" : "#9aa0a6"
                                  // }}
                                >
                                  {t.active ? "Active" : "Inactive"}
                                </span>
                              </div>
                            </td>

                            <td className="anp-actins sales-tier-actions-col" style={{ textAlign: "center" }}>
                              <button className="edit-icon-btn"
                              style={{width:"32px", height:"32px"}} onClick={() => onEditSalesTier(i)}>
                                <img src={editIcon} alt="Edit" className="edit-icon" />
                              </button>

                              {/* <button className="delete-icon-btn" onClick={() => onDeleteSalesTier(i)}>
                                <img src={deleteIcon} alt="Delete" className="delete-icon" />
                              </button> */}

                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                  </div>
                  {errors["sale.sellPriceTiers"] && <p className="error-msg">{errors["sale.sellPriceTiers"]}</p>}
                </div>
              )}
            </div>
          </div>

          <div className="anp-right">

            <div className="anp-card">
              <div className="anp-card-types">
              <h3>Types</h3>

              {TYPE_LIST.map((type) => (
                <div key={type} className="anp-type-toggle">
                  <label className="switch">
                    <input type="checkbox" checked={form.types[type]} onChange={() => handleTypeToggle(type)} />
                    <span className="slider round" />
                  </label>
                  <span style={{ marginLeft: 10 }}>{type}</span>
                </div>
              ))}
</div>
              <div className="anp-group">
                <label>Notes</label>
                <textarea rows={3} maxLength={PRODUCT_FIELD_LIMITS.notes} value={form.notes} placeholder="Type your notes here" onChange={(e) => handleInput("notes", e.target.value)} />
                {errors["notes"] && <p className="error-msg">{errors["notes"]}</p>}
              </div>

              <div className="anp-group">
                <label className="label-with-tooltip">
                  Reminders
                  <InfoTooltip message="This reminder will appear each time this product is added to Sales Quotes, Sales Orders and Purchase Orders." />
                  
                </label>

                <textarea rows={3} maxLength={PRODUCT_FIELD_LIMITS.reminders} value={form.reminders} placeholder="Add reminders here" onChange={(e) => handleInput("reminders", e.target.value)} />
                {errors["reminders"] && <p className="error-msg">{errors["reminders"]}</p>}
              </div>

              <div className="anp-group">
                <label className="label-with-tooltip">
                    Comments
                    <InfoTooltip message="Enable the options below if you want this comment to auto populate through to the purchase order, sales order, or sales quote line comment for this product." />
                  </label> 

                <label className="checkbox-line">
                  <input type="checkbox" checked={form.addToSales} onChange={(e) => handleInput("addToSales", e.target.checked)} />
                  Add to sales quotes & orders
                </label>

                <label className="checkbox-line">
                  <input type="checkbox" checked={form.addToPurchase} onChange={(e) => handleInput("addToPurchase", e.target.checked)} />
                  Add to purchase Order
                </label>

                <textarea rows={3} maxLength={PRODUCT_FIELD_LIMITS.comments} value={form.comments} placeholder="Add comments here" onChange={(e) => handleInput("comments", e.target.value)} />
              </div>
              <div className="anp-action-row">
              <button className="anp-cancel" onClick={() => navigate("/products")}>Cancel</button>
              <button className="anp-save"  onClick={() => {
    setPendingSave(() => handleSave); 
    setIsConfirmOpen(true);
  }}>{isEditMode ? "Update" : "Save"}</button>
            </div>
            </div>

          </div>
        </div>

        {errors["comments"] && <p className="error-msg">{errors["comments"]}</p>}
      </div>

      {/* Unit Modal */}
      {(isAddUnitOpen || isEditUnitOpen) && (
        <div className="modal-overlay">
          <motion.div className="modal-content" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.9 }}>
            <div className="modal-header">
              <h3>{isEditUnitOpen ? "Edit Unit" : "Add Unit"}</h3>
              <div className="unit-modal-header-actions">
                <div className="unit-header-switch">
                  <label className="switch">
                    <input type="checkbox" checked={newUnit.purchasable} onChange={() => setNewUnit((s) => ({ ...s, purchasable: !s.purchasable }))} />
                    <span className="slider round"></span>
                  </label>
                  <span>Purchasable</span>
                </div>
                <button className="close-btn" onClick={() => { setIsAddUnitOpen(false); setIsEditUnitOpen(false); setEditUnitIndex(null); }}>✕</button>
              </div>
            </div>

            <div className="modal-grid">
              <div className="modal-field">
                <label>Name <InfoTooltip message="Please enter the base unit name like EA, ML, Each, KG, METRE, MM..." /></label>
                <input type="text" 
                placeholder="Enter Name"
                value={newUnit.name} onChange={(e) => setNewUnit((s) => ({ ...s, name: e.target.value }))} />
                {unitErrors.name && <p className="error-msg">{unitErrors.name}</p>}
              </div>
              <div className="modal-field">
              <label>
                Entity {/* <span className="required-asterisk">*</span> */}
              </label>

              <CustomSelect
                value={newUnit.entity}
                onChange={(v) =>
                  setNewUnit((u) => ({ ...u, entity: v }))
                }
                options={entityOptions}
                placeholder="Select Entity"
                disabled={isEditUnitOpen}
              />

              {unitErrors.entity && (
                <p className="error-msg">{unitErrors.entity}</p>
              )}
            </div>


              <div className="modal-field">
                <label>Conversion Rate</label>
                <input type="text" 
                placeholder="Enter"
                value={newUnit.conversionRate} onChange={(e) => handleConversionRateInput(e.target.value)} />
                 {unitErrors.conversionRate && (
    <p className="error-msg">{unitErrors.conversionRate}</p>
  )}
              </div>

              <div className="modal-field">
                <label>Pack Size {/* <span className="required-asterisk">*</span> */}</label>
                <input type="text" placeholder="Enter"
                value={newUnit.packSize} onChange={(e) => handleUnitNumberInput("packSize", e.target.value)} />
                {unitErrors.packSize && <p className="error-msg">{unitErrors.packSize}</p>}
              </div>

              <div className="modal-field">
                <label>Weight</label>
                <input type="text" placeholder="Enter"
                value={newUnit.weight} onChange={(e) => handleUnitDecimalInput("weight", e.target.value)} />
                {unitErrors.weight && <p className="error-msg">{unitErrors.weight}</p>}
              </div>

              <div className="modal-field">
                <label>Barcode{/* <span className="required-asterisk">*</span> */}</label>
                <input type="text" placeholder="Enter"
                maxLength={PRODUCT_FIELD_LIMITS.barcode}
                value={newUnit.barcode} onChange={(e) => {
                  const nextValue = trimToFieldLimit("barcode", e.target.value);
                  setNewUnit((s) => ({ ...s, barcode: nextValue }));
                  setUnitErrors((prev) => ({
                    ...prev,
                    barcode: getFieldValidationError("barcode", nextValue),
                  }));
                }} />
                {unitErrors.barcode && <p className="error-msg">{unitErrors.barcode}</p>}
              </div>

              <div className="modal-field full">
                <label>Dimensions (WxHxD)</label>
                <div className="dimensions">
                  <input
                  type="text"
                  inputMode="decimal"
                  placeholder="0  "
                  value={newUnit.dimensions.width}
                  onChange={(e) => handleDimensionNumberInput("width", e.target.value)}
                />
                  <span 
                  style={{
                    color:"#7509B8"
                  }}>X</span>
                  <input
                  type="text"
                  inputMode="decimal"
                  placeholder="0  "
                  value={newUnit.dimensions.height}
                  onChange={(e) => handleDimensionNumberInput("height", e.target.value)}
                />
                  <span 
                  style={{
                    color:"#7509B8"
                  }}>X</span>
                 <input
                type="text"
                inputMode="decimal"
                placeholder="0  "
                value={newUnit.dimensions.depth}
                onChange={(e) => handleDimensionNumberInput("depth", e.target.value)}
              />
                </div>
              </div>
            </div>

            <div className="modal-actions">
              <button className="cancel-btn" onClick={() => { setIsAddUnitOpen(false); setIsEditUnitOpen(false); setEditUnitIndex(null); }}>Cancel</button>
              <button className="add-btn" onClick={onSaveUnit}>{isEditUnitOpen ? "Save Changes" : "Add Unit"}</button>
            </div>
          </motion.div>
        </div>
      )}

      {/* Sales Tier Modals */}
      {isAddSalesTierOpen && (
        <div className="modal-overlay">
          <motion.div className="modal-content sales-tier-modal" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }}>
            <div className="modal-header">
              <h3>Add Sales Tier</h3>
              <button
  className="close-btn"
  onClick={() => {
    setIsAddSalesTierOpen(false);
    resetSalesTierForm();         
  }}
>
  ✕
</button>
            </div>

            <div className="modal-grid sales-tier-grid">
              <div className="modal-field">
                <label>Entity<span className="required-asterisk">*</span></label>
                <CustomSelect
  value={newSalesTier.entity}
  onChange={(v) => setNewSalesTier(s => ({ ...s, entity: v }))}
  options={availableEntityOptions}
  placeholder="Select Entity"
/>
                {salesTierErrors.entity && <p className="error-msg">{salesTierErrors.entity}</p>}
              </div>
                            <div className="modal-field">
  <label>
    Default Sell Price<span className="required-asterisk">*</span>
  </label>

  <div className="price-input-wrapper">
    {newSalesTier.entity && (
      <span className="currency-prefix">
        {currencyMap?.[newSalesTier.entity] ?? ""}
      </span>
    )}

    <input
      type="text"
      placeholder="Enter"
      value={newSalesTier.price}
      className={newSalesTier.entity ? "with-prefix" : ""}
      onChange={(e) => {
        const val = e.target.value;
        if (val === "" || validateTierPrice(val)) {
          setNewSalesTier((s) => ({ ...s, price: val }));
        }
      }}
    />
  </div>

  {salesTierErrors.price && (
    <p className="error-msg">{salesTierErrors.price}</p>
  )}
</div>

                            <div className="modal-field">
  <label>
    Minimum Sell Price<span className="required-asterisk">*</span>
  </label>

  <div className="price-input-wrapper">
    {newSalesTier.entity && (
      <span className="currency-prefix">
        {currencyMap?.[newSalesTier.entity] ?? ""}
      </span>
    )}

    <input
      type="text"
      placeholder="Enter"
      value={newSalesTier.minimumSellPrice}
      className={newSalesTier.entity ? "with-prefix" : ""}
      onChange={(e) => {
        const val = e.target.value;
        if (val === "" || validateTierPrice(val)) {
          setNewSalesTier((s) => ({ ...s, minimumSellPrice: val }));
        }
      }}
    />
  </div>

  {salesTierErrors.minimumSellPrice && (
    <p className="error-msg">{salesTierErrors.minimumSellPrice}</p>
  )}
</div>

              <div className="modal-field">
  <label>Landed Cost</label>

  <div className="price-input-wrapper">
    {newSalesTier.entity && (
      <span className="currency-prefix">
        {currencyMap?.[newSalesTier.entity] ?? ""}
      </span>
    )}

    <input
      type="text"
      placeholder="Enter"
      value={newSalesTier.landedCost}
      className={newSalesTier.entity ? "with-prefix" : ""}
      onChange={(e) => {
        const val = e.target.value;
        if (val === "" || validateTierPrice(val)) {
          setNewSalesTier((s) => ({ ...s, landedCost: val }));
        }
      }}
    />
  </div>
</div>

              {/* <div className="modal-field">
                <label>Tier<span className="required-asterisk">*</span></label>
                <input
  type="text"
  placeholder="Enter Name"
  value={newSalesTier.tier}
  onChange={(e) => {
    const val = e.target.value;
    if (!blockLeadingSpace(val)) return;
    if (!validateString255(val)) return;
    setNewSalesTier(s => ({ ...s, tier: val }));
  }}
/>
                {salesTierErrors.tier && <p className="error-msg">{salesTierErrors.tier}</p>}
              </div> */}


              {/* <div className="modal-field">
                <label>Product Code<span className="required-asterisk">*</span></label>
                <input
  type="text"
  placeholder="Enter"
  value={newSalesTier.productCode}
  onChange={(e) => {
    const val = e.target.value;
    if (!blockLeadingSpace(val)) return;
    setNewSalesTier(s => ({ ...s, productCode: val }));
  }}
/>

                {salesTierErrors.productCode && <p className="error-msg">{salesTierErrors.productCode}</p>}
              </div> */}

              {/* <div className="modal-field">
                <label>SKU<span className="required-asterisk">*</span></label>
<input
  type="text"
  placeholder="Enter"
  value={newSalesTier.sku}
  onChange={(e) => {
    const val = e.target.value;
    if (!blockLeadingSpace(val)) return;
    if (!validateString255(val)) return;
    setNewSalesTier(s => ({ ...s, sku: val }));
  }}
/>
{salesTierErrors.sku && <p className="error-msg">{salesTierErrors.sku}</p>}

              </div>
<div className="modal-field">
  <label>
    Commerce Code
  </label>
  <input
    type="text"
    placeholder="Enter Commerce Code"
    value={newSalesTier.commerceCode}
    onChange={(e) =>
      setNewSalesTier(s => ({ ...s, commerceCode: e.target.value }))
    }
  />
  {salesTierErrors.commerceCode && (
    <p className="error-msg">{salesTierErrors.commerceCode}</p>
  )}
</div>
 <div className="modal-field full-row">
                <label>Description<span className="required-asterisk">*</span></label>
                <textarea
  rows={3}
  placeholder="Enter Description"
  value={newSalesTier.description}
  onChange={(e) => {
    const val = e.target.value;
    if (!blockLeadingSpace(val)) return;
    if (!validateString255(val)) return;
    setNewSalesTier(s => ({ ...s, description: val }));
  }}
/>
                {salesTierErrors.description && <p className="error-msg">{salesTierErrors.description}</p>}
              </div>

<div className="modal-field full-row">
  <label>Customs Description</label>
  <textarea
    rows={2}
    placeholder="Enter Customs Description"
    value={newSalesTier.customsDescription}
    onChange={(e) =>
      setNewSalesTier(s => ({ ...s, customsDescription: e.target.value }))
    }
  />
</div> */}

             
            </div>

            <div className="modal-actions">
              <button
  className="cancel-btn"
  onClick={() => {
    setIsAddSalesTierOpen(false);
    resetSalesTierForm();
  }}
>
  Cancel
</button>
              <button className="add-btn" onClick={onSaveSalesTier}>Add Tier</button>
            </div>
          </motion.div>
        </div>
      )}

      {isEditSalesTierOpen && (
        <div className="modal-overlay">
          <motion.div className="modal-content sales-tier-modal" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }}>
            <div className="modal-header">
              <h3>Edit Sales Tier</h3>
              <button
  className="close-btn"
  onClick={() => {
    setIsEditSalesTierOpen(false);
    resetSalesTierForm();
  }}
>
  ✕
</button>
            </div>

            <div className="modal-grid sales-tier-grid">
              <div className="modal-field">
                <label>Entity<span className="required-asterisk">*</span></label>
                <CustomSelect
  value={newSalesTier.entity}
  onChange={(v) => setNewSalesTier(s => ({ ...s, entity: v }))}
  options={availableEntityOptions}
  placeholder="Select Entity"
/>
              </div>

              {/* <div className="modal-field">
                <label>Tier<span className="required-asterisk">*</span></label>
                <input type="text" 
                value={newSalesTier.tier} onChange={(e) => setNewSalesTier((s) => ({ ...s, tier: e.target.value }))} />
              </div> */}

              <div className="modal-field">
              <label>
                Default Sell Price <span className="required-asterisk">*</span>
              </label>

            <div className="price-input-wrapper">
              {newSalesTier.entity && (
                <span className="currency-prefix">
                  {currencyMap?.[newSalesTier.entity] ?? ""}
                </span>
              )}

              <input
                type="text"
                value={newSalesTier.price}
                className={newSalesTier.entity ? "with-prefix" : ""}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "" || validateTierPrice(val)) {
                    setNewSalesTier((s) => ({ ...s, price: val }));
                  }
                }}
              />
            </div>

            {salesTierErrors.price && (
              <p className="error-msg">{salesTierErrors.price}</p>
            )}
          </div>
<div className="modal-field">
  <label>
    Minimum Sell Price <span className="required-asterisk">*</span>
  </label>

  <div className="price-input-wrapper">
    {newSalesTier.entity && (
      <span className="currency-prefix">
        {currencyMap?.[newSalesTier.entity] ?? ""}
      </span>
    )}

    <input
      type="text"
      value={newSalesTier.minimumSellPrice}
      className={newSalesTier.entity ? "with-prefix" : ""}
      onChange={(e) => {
        const val = e.target.value;
        if (val === "" || validateTierPrice(val)) {
          setNewSalesTier((s) => ({ ...s, minimumSellPrice: val }));
        }
      }}
    />
  </div>
   {salesTierErrors.minimumSellPrice && (
    <p className="error-msg">{salesTierErrors.minimumSellPrice}</p>
  )}
</div>
              <div className="modal-field">
              <label>Landed Cost</label>

            <div className="price-input-wrapper">
              {newSalesTier.entity && (
                <span className="currency-prefix">
                  {currencyMap?.[newSalesTier.entity] ?? ""}
                </span>
              )}

              <input
                type="text"
                value={newSalesTier.landedCost}
                className={newSalesTier.entity ? "with-prefix" : ""}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "" || validateTierPrice(val)) {
                    setNewSalesTier((s) => ({ ...s, landedCost: val }));
                  }
                }}
              />
            </div>
          </div>


              {/* <div className="modal-field">
                <label>Product Code<span className="required-asterisk">*</span></label>
                <input type="text"  value={newSalesTier.productCode} onChange={(e) => setNewSalesTier((s) => ({ ...s, productCode: e.target.value }))} />
              </div> */}

              {/* <div className="modal-field">
                <label>SKU<span className="required-asterisk">*</span></label>
                <input type="text" value={newSalesTier.sku} onChange={(e) => setNewSalesTier((s) => ({ ...s, sku: e.target.value }))} />
              {salesTierErrors.sku && <p className="error-msg">{salesTierErrors.sku}</p>}
              </div>
              <div className="modal-field">
  <label>
    Commerce Code
  </label>
  <input
    type="text"
    placeholder="Enter Commerce Code"
    value={newSalesTier.commerceCode}
    onChange={(e) =>
      setNewSalesTier(s => ({ ...s, commerceCode: e.target.value }))
    }
  />
  {salesTierErrors.commerceCode && (
    <p className="error-msg">{salesTierErrors.commerceCode}</p>
  )}
</div>

<div className="modal-field full-row">
                <label>Description<span className="required-asterisk">*</span></label>
                <textarea rows={3} value={newSalesTier.description} onChange={(e) => setNewSalesTier((s) => ({ ...s, description: e.target.value }))} />
              </div>

<div className="modal-field full-row">
  <label>Customs Description</label>
  <textarea
    rows={2}
    placeholder="Enter Customs Description"
    value={newSalesTier.customsDescription}
    onChange={(e) =>
      setNewSalesTier(s => ({ ...s, customsDescription: e.target.value }))
    }
  />
</div> */}

            </div>

            <div className="modal-actions">
              <button
  className="cancel-btn"
  onClick={() => {
    setIsEditSalesTierOpen(false);
    resetSalesTierForm();
  }}
>
  Cancel
</button>
              <button className="add-btn" onClick={() => {
                if (!validateSalesTier(newSalesTier)) return;
                const updated = [...salesTiers];
                updated[editSalesTierIndex] = newSalesTier;
                setSalesTiers(updated);
                setIsEditSalesTierOpen(false);
                setEditSalesTierIndex(null);
                resetSalesTierForm();
              }}>Save Changes</button>
            </div>
          </motion.div>
        </div>
      )}
      <ConfirmModal
  open={isConfirmOpen}
  title={isEditMode ? "Update Product" : "Save Product"}
  message={
    isEditMode
      ? "Are you sure you want to update this product?"
      : "Are you sure you want to save this new product?"
  }
  confirmText={isEditMode ? "Update" : "Save"}
  cancelText="Cancel"
  confirmType="primary"
  onCancel={() => setIsConfirmOpen(false)}
  onConfirm={() => {
    setIsConfirmOpen(false);
    if (pendingSave) pendingSave(); 
  }}
/>
<ConfirmModal
  open={isDeleteConfirmOpen}
  title="Delete Confirmation"
  message={
    deleteType === "unit"
      ? "Are you sure you want to delete this Unit of Measure?"
      : "Are you sure you want to delete this Sales Tier?"
  }
  confirmText="Delete"
  cancelText="Cancel"
  confirmType="danger"
  onCancel={() => setIsDeleteConfirmOpen(false)}
  onConfirm={() => performDelete()}
/>
    </div>
    )
  );
};

export default AddNewProduct;


